import { useContext as o } from "react";
import { NotificationContext as r } from "../NotificationProvider.js";
const t = () => {
  const { push: t2 } = o(r);
  return { push: t2 };
};
export {
  t as useNotifications
};
//# sourceMappingURL=useNotifications.js.map
